import { QueryClient } from '@tanstack/react-query';

/**
 * One QueryClient for the app.
 *
 * refetchOnWindowFocus stays ON deliberately: it is the cheap, correct
 * replacement for the always-on polling intervals this codebase used - data
 * refreshes when the user actually comes back to the tab, and never while
 * the tab sits hidden.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 1,
			refetchOnWindowFocus: true,
			staleTime: 30 * 1000,
		},
	},
});
